<div>

    <button (click)="openModal()" nz-button nzType="primary" nzShape="circle">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
    </button>

    <nz-table #basicTable [nzData]="payPlanAttributes">
        <thead>
          <tr>
            <th>Provider</th>
            <th>Payplan Attributes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let att of basicTable.data">
            <td>{{ att.provider }}</td>
            <td>{{ att.attributes }}</td>
            <td>
                <button nz-button nzType="primary" nzShape="circle">
                    <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
            </td>
          </tr>
        </tbody>
      </nz-table>

</div>


<nz-modal (nzOnCancel)="closeModal()" [(nzVisible)]="attributeModal" nzTitle="Payplan Attributes" [nzFooter]="null">
    <ng-container *nzModalContent>
        <form [formGroup]="attributeForm">

            <nz-form-item>
                <nz-form-label>Provider</nz-form-label>
                <nz-form-control>
                    <nz-select nzShowSearch nzAllowClear formControlName="provider_id" style="width: 100%;">
                        <nz-option *ngFor="let p of providers" [nzValue]="p.id" [nzLabel]="p.name"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item> 

            <nz-form-control>
                <nz-form-label nzFor="dropdownField">
                    Attributes (Press Enter to Add, Then Save)
                </nz-form-label>
                <input nz-input formControlName="attributes" (keyup.enter)="addChip()" placeholder="Enter attributes" />
                <nz-tag *ngFor="let chip of atts" nzMode="closeable" (nzOnClose)="removeChip(chip)">
                  {{ chip }}
                </nz-tag>
              </nz-form-control>

        </form>

        <button nz-button nzType="primary" (click)="save()">Save</button>
        
    </ng-container>
</nz-modal>